import { useMemo } from "react";

import { AccessSessionsApi, Configuration } from "../../api/v1";
import { useClientContext } from "../../providers";

export default function useAccessSessionApi() {
  const { accessToken, basePath } = useClientContext();

  return useMemo(
    () =>
      new AccessSessionsApi(
        new Configuration({
          accessToken,
          basePath,
        }),
      ),
    [accessToken, basePath],
  );
}
